import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { AdminTaxonomyDashboardRoutingModule } from './admin-taxonomy-dashboard-routing.module';
import { AdminTaxonomyDashboardComponent } from './admin-taxonomy-dashboard.component';
import { ArticleTaxonomyAnalysisComponent } from './article-taxonomy-analysis/article-taxonomy-analysis.component';
import { CategoryAnalysisComponent } from './category-analysis/category-analysis.component';
import { SystemConfidenceAnalysisComponent } from './system-confidence-analysis/system-confidence-analysis.component';

@NgModule({
  declarations: [
    AdminTaxonomyDashboardComponent,
    ArticleTaxonomyAnalysisComponent,
    CategoryAnalysisComponent,
    SystemConfidenceAnalysisComponent,
  ],
  imports: [CommonModule, HttpClientModule, RouterModule, IonicModule, AdminTaxonomyDashboardRoutingModule],
})
export class AdminTaxonomyDashboardModule {}
